






















import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import BcAccessPointTable from '@access-control/components/tables/access-point/access-point-table.vue';
import ContentWrapper from '@shared/layouts/wrappers/content-wrapper.vue';

@Component({
  name: 'bpc-access-points-page',
  components: {
    'bc-access-point-table': BcAccessPointTable,
    'bpc-content-wrapper': ContentWrapper,
  },
})
export default class AccessPointsPage extends Vue {
  // PROPS
  // DATA
  // LIFECYCLE
  // created(){}
  // mounted(){}
  // updated(){}
  // destroyed(){}
  // COMPUTED

  // This computed property generates a unique ID for the actions portal using the generateUUIDv4 method from the $bpcHelper helper.
  get actionsPortalTarget() {
    return `access-point-actions-${this.$bpcHelper.generateUUIDv4()}`;
  }
  // METHODS
  // WATCHERS
}
